<section id="hero">
    <div class="content">
        <div class="hero-image">
            <img src="/assets/images/hero_pic.png" alt="">
        </div>

        <div class="hero-right">
            <div class="namesection">
                <div class="vertical-I-am">{{text.iam}}</div>
                <div class="namesection-right">
                    <span class="name">Irina Gorges</span>
                    <span class="frontend">{{text.title}}</span>
                </div>
            </div>
            <div class="buttonsec">
                <a href="#contact">{{text.cta}}</a>
            </div>
        </div>
    </div>
</section>